// ============================================================================
// TENANT ENDPOINTS
// ============================================================================
// Endpoint definitions for Tenant Management module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for tenant endpoints
 */
const BASE_PATH = '/tenants';

/**
 * Tenant Endpoints
 */
export const tenantEndpoints = {
  /**
   * Get all tenants (paginated)
   * GET /tenants
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get tenant by ID
   * GET /tenants/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Get tenant by code
   * GET /tenants/code/:code
   */
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /**
   * Get tenant summaries
   * GET /tenants/summary
   */
  summaries: () => buildEndpoint(`${BASE_PATH}/summary`),

  /**
   * Create new tenant
   * POST /tenants
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update tenant
   * PUT /tenants/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete tenant
   * DELETE /tenants/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Suspend tenant
   * POST /tenants/:id/suspend
   */
  suspend: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/suspend`, { id }),

  /**
   * Activate tenant
   * POST /tenants/:id/activate
   */
  activate: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/activate`, { id }),

  /**
   * Get tenant statistics
   * GET /tenants/statistics
   */
  statistics: () => buildEndpoint(`${BASE_PATH}/statistics`),
} as const;

/**
 * Export endpoints
 */
export default tenantEndpoints;
